import classNames from 'classnames';
import { ApsTray, ApsTrayBody, ApsTrayHeader } from 'UserExperience/portal-vnext';
import { useTranslation } from 'react-i18next';


const Tray = ({ isTrayOpen, closeTray, children }) => {

  const { t } = useTranslation();

  const trayClass = classNames({
    'tray-open': isTrayOpen === true
  });

  return (
    <ApsTray
      id="start-page-bottom-tray"
      trayPosition="right"
      className={trayClass}
    >
      <ApsTrayHeader
        headerTitle={t('addDocumentTray.trayTitle')}
        headerCloseClick={closeTray}
      />
      <ApsTrayBody>
        {children}
      </ApsTrayBody>
    </ApsTray>
  );
};

export default Tray;